import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newInnvoice({ state }) {
    let invoiceDetails = {
      invoice_no: $(".invoice_no").val(),
      consignee_name: $(".consignee_name").val(),
      bl_no: $(".bl_no").val(),
      cargo: $(".cargo").val(),
      invoice_date: $(".invoice_date").val(),
      total: $(".total").val(),
      container_details: state.container_details,
      invoice_items: state.invoice_items
    };

    $(".creatingInvoice").hide();
    $(".creatingInvoiceLoader").show;
    baseurl.post(rt.newInvoice, invoiceDetails).then(res => {
      $(".creatingInvoice").show();
      $(".creatingInvoiceLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success codes
        suc.invoicesCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorCreatingInvoice();
      } else if (res.data.code === 405) {
          //no permission to create
          ers.noPermissionToCreate()
      } else if (res.data.code === 506) {
         //session expired
         ses.sessionComplete(); 
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/invoices/actions.js